/**
 * Updates the intervals after making an assignment [TASK INTERVALS]
 * @param {*} applicant The applicant being assigned
 * @param {*} variable The variable the applicant is being assigned to
 * @param {*} variableConflictMap The map that maps each applicant to the variables they are available for and the conflicts
 * @param {*} intervals The intervals used for search
 * @param {*} intervalTaskMap Map of tasks to the interval they correspond to
 */
// export function assignIntervalUpdate(applicant, variable, variableConflictMap, intervals, intervalTaskMap) {
//   const affectedTasks = variableConflictMap[applicant.vName][variable.name.split('-')[0]];
//   affectedTasks.forEach(task => {
//     const interval = intervalTaskMap[task];
//     intervals[interval].ds -= 1;
//   });
// }

/**
 * Updates the intervals after removing an assignment [TASK INTERVALS]
 * @param {*} applicant The applicant being unassigned
 * @param {*} variable The variable the applicant is being unassigned from
 * @param {*} variableConflictMap The map that maps each applicant to the variables they are available for and the conflicts
 * @param {*} intervals The intervals used for search
 * @param {*} intervalTaskMap Map of tasks to the interval they correspond to
 */
// export function unassignIntervalUpdate(applicant, variable, variableConflictMap, intervals, intervalTaskMap) {
//   const affectedTasks = variableConflictMap[applicant.vName][variable.name.split('-')[0]];
//   affectedTasks.forEach(task => {
//     const interval = intervalTaskMap[task];
//     intervals[interval].ds += 1;
//   });
// }

/**
 * Updates intervals in accordance with an assignment in search
 * @param {string} taskName The name of the task that has been assigned without the "-#"/ Ex: V0
 * @param {*} filteredTasks The unique tasks that were filtered by the assignment. Array of objects in form {name: variableName without "-#", amount: number of values filtered out of domain}
 * @param {*} intervals The interval map to be updated
 * @param {*} intervalTaskMap Maps a task to the intervals it is in
 */
export function assign(taskName, filteredTasks, intervals, intervalTaskMap) {
  // Get invervals task is part of and update unassigned
  const visitedInts = new Set();
  const ints = intervalTaskMap[taskName];
  ints.forEach(interval => {
    intervals[interval].tasks[taskName].unassigned -= 1;
    visitedInts.add(interval);
  });
  // Get intervals for each of the filteredVars and how many and update avial
  filteredTasks.forEach(fvar => {
    const fints = intervalTaskMap[fvar.name];
    fints.forEach(finterval => {
      intervals[finterval].tasks[fvar.name].domain -= fvar.amount;
      visitedInts.add(finterval);
    });
  });
  // Update dS for all affected intervals
  visitedInts.forEach(interval => {
    let dS = 0;
    Object.keys(intervals[interval].tasks).forEach(task => {
      const t = intervals[interval].tasks[task];
      const taskDS = t.domain - t.unassigned;
      if (taskDS < 0) {
        dS += taskDS;
      }
    });
    intervals[interval].dS = dS;
  });
}

/**
 * Updates intervals in accordance with an unassignment in search
 * @param {string} taskName The name of the task that has been unassigned without the "-#"/ Ex: V0
 * @param {*} filteredTasks The unique tasks that were filtered by the unassignment. Array of objects in form {name: variableName without "-#", amount: number of values filtered out of domain}
 * @param {*} intervals The interval map to be updated
 * @param {*} intervalTaskMap Maps a task to the intervals it is in
 */
export function unassign(taskName, filteredVars, intervals, intervalTaskMap) {
  // Get invervals task is part of and update unassigned
  const visitedInts = new Set();
  const ints = intervalTaskMap[taskName];
  ints.forEach(interval => {
    intervals[interval].tasks[taskName].unassigned += 1;
    visitedInts.add(interval);
  });
  // Get intervals for each of the filteredVars and how many and update avial
  filteredVars.forEach(fvar => {
    const fints = intervalTaskMap[fvar.name];
    fints.forEach(finterval => {
      intervals[finterval].tasks[fvar.name].domain += fvar.amount;
      visitedInts.add(finterval);
    });
  });
  // Update dS for all affected intervals
  visitedInts.forEach(interval => {
    let dS = 0;
    Object.keys(intervals[interval].tasks).forEach(task => {
      const t = intervals[interval].tasks[task];
      const taskDS = t.domain - t.unassigned;
      if (taskDS < 0) {
        dS += taskDS;
      }
    });
    intervals[interval].dS = dS;
  });
}

/**
 * Gets the total solution quality for all intervals
 * @param {*} intervals The intervals for the search
 * @returns The solution quality for all intervals
 */
export function getSolutionQuality(intervals) {
  let quality = 1;
  Object.keys(intervals).forEach(interval => {
    const intervalDS = intervals[interval].dS;
    if (intervalDS < 0) {
      quality *= intervalDS;
    }
  });
  return -Math.abs(quality);
}

/**
 * Prints the solution in a human-readable format.
 * @param {Array|boolean} solution - The solution returned by the iterativeBacktrackingSearch function.
 */
export function printSolution(solution) {
  if (solution === false) {
    console.log('No solution found.');
  } else {
    console.log('Solution found:');
    console.log(solution);
    solution.forEach((a) => {
      console.log(
        `${a.variable} assigned to ${a.assignment.vName} ${a.assignment.aName}`
      );
    });
  }
}

export function checker(solution, problemInstance) {
  let violated = 0;
  problemInstance.constraints.forEach(constraint => {
    const scope = constraint.variables;
    const var1 = scope[0];
    let var2;

    // Unary constraints
    if (scope.length === 1) {
      const name = var1.variableName;
      const v1 = solution.find((element) => element.variable === name).assignment;
      let good;
      if (constraint.name.includes('pref')) {
        // Admin pref constraint
        const preferences = problemInstance.taskPreferences;
        const { id } = var1;
        const tp = preferences.find(p => p.task_id === id && p.status_id === v1.status.id);

        good = constraint.definition(v1, tp);
      } else {
        // Applicant in task time constraint
        const time = {
          starts_at: var1.startTime,
          ends_at: var1.endTime,
        };
        good = constraint.definition(time, v1);
      }

      if (!good) {
        violated += 1;
      }
    } else {
      // Binary constraint, two tasks at same time cannot be assigned the same applicant
      // eslint-disable-next-line prefer-destructuring
      var2 = scope[1];
      const v1Name = var1.variableName;
      const v1 = solution.find((element) => element.variable === v1Name).assignment;

      const v2Name = var2.variableName;
      const v2 = solution.find((element) => element.variable === v2Name).assignment;

      const good = constraint.definition(v1, v2);
      if (!good) {
        violated += 1;
      }
    }
  });
  console.log('number violated');
  console.log(violated);
}
